import { Component,Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-project-step',
  templateUrl: './project-step.component.html',
  styleUrls: ['./project-step.component.scss', '../../../../mystery-shopper/mystery-shopper.component.scss']

})
export class ProjectStepComponent {

  @Input() step: string = "";
  @Input() projectId: string = ''
  projectStatus: any[] = [
    { name: "Weights", status: "", link:"/ms/assign-weights/" },
    { name: "Criteria", status: "",link:"/ms/criterias/" },
    { name: "Enquiries", status: "",link:"/ms/factor/" },
    { name: "Calander", status: "",link:"/ms/calender/" },
    { name: "Evaluation", status: "",link:"/ms/evaluation/" }
  ];
  evaluationEnabled: boolean = false;
  evaluations: any;
  evaluationsStatus: any;


  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
  ) { }

  async ngOnInit() {
    await this.getEvaluations();
    this.getStepStatus();
  }

  async getStepStatus(){
    try {
      let res = await this.dataService.getData('ms-step/project/' + this.projectId);
      if (res.error) return

      let allStepsApproved = true;
      this.projectStatus.forEach((projectStep: any) => {
        const matchedStep = res.data.find((step: any) => step._id == projectStep.name);
        if (matchedStep) {
            projectStep.status = matchedStep.approvalStatus;

            if (matchedStep.approvalStatus !== 'Approved') {
              allStepsApproved = false;
            }
            else {
            allStepsApproved = false;
          }
        }
        if(projectStep.name != 'Evaluation')
        {
          projectStep.cssClass = this.getStatusClass(projectStep.name,projectStep.status);
        }
        else{
          projectStep.cssClass = this.getStatusClass(projectStep.name,this.evaluationsStatus);
        }
        let stepsToCheck = this.projectStatus.slice(0, this.projectStatus.length - 1);
        this.evaluationEnabled = stepsToCheck.every(step => step.status === 'Approved');
      });
    } catch (error) {
      console.log(error)
    }
  }

  getStatusClass(name:string ,status:string){
    let cssClass = ""
    if (status == 'Approved'){
      cssClass = 'pg-num-approved';
    } else if (status == 'Redo'){
      cssClass ='pg-num-redo';
    } else if (status == 'Pending'){
      cssClass ='pg-num-pending';
    } else if (status == 'Change'){
      cssClass ='pg-num-change';
    }
    if (name == this.step)
    {
      cssClass += " active";
    }
    return cssClass;
  }

  async getEvaluations(){
    try {
      let res = await this.dataService.getData('ms-evaluation/project/' + this.projectId);
      if (res.error) return
      this.evaluations = res.data;
      this.evaluationsStatus = this.countHighestStatus(this.evaluations);
    } catch (error) {
      console.log(error)
    }
  }

  countHighestStatus(objects: any[]): string {
    const counts: Record<string, number> = {};
    for (const obj of objects) {
      const status = obj.approvalStatus;
      if (status !== undefined) {
        counts[status] = (counts[status] || 0) + 1;
      }
    }
    
    let highestCount = 0;
    let highestStatus = '';

    for (const status in counts) {
      if (counts.hasOwnProperty(status)) {
        const count = counts[status];
        if (count > highestCount) {
          highestCount = count;
          highestStatus = status;
        }
      }
    }
    return highestStatus;
  }
}
